import { FC } from 'react';

import { useIntl, defineMessages } from 'dibs-react-intl';
import ExclamationCircle from 'dibs-icons/exports/legacy/ExclamationCircle';
import { Link } from 'dibs-elements/exports/Link';

import { NftItemImportErrorReason as ErrorReason } from './__generated__/NftProfileImportCollectionRetry_nftItem.graphql';

import styles from './styles/NftProfileImportCollectionRetry.scss';

const errorMessages = defineMessages({
    error: {
        id: 'nftProfile.importCollectionRetryError.error',
        defaultMessage: 'Unable to import NFT',
    },
    unknown: {
        id: 'nftProfile.importCollectionRetryError.unknown',
        defaultMessage: 'There were errors in the import process.',
    },
    invalid: {
        id: 'nftProfile.importCollectionRetryError.invalid',
        defaultMessage: 'The file type of this NFT is not supported.',
    },
    tryAgain: { id: 'nftProfile.importCollectionRetryError.tryAgain', defaultMessage: 'Try Again' },
});

const getErrorCopy = (reason?: ErrorReason | null): { id: string; defaultMessage: string } =>
    reason === 'NFT_ITEM_IMPORT_ERROR_REASON_INVALID_MEDIA'
        ? errorMessages.invalid
        : errorMessages.unknown;

export const NftProfileImportCollectionRetryError: FC<{
    onRetry: () => void;
    errorReason?: ErrorReason | null;
    canRetry: boolean;
}> = ({ errorReason, onRetry, canRetry }) => {
    const { formatMessage } = useIntl();
    const errorCopy = getErrorCopy(errorReason);
    return (
        <div className={styles.errorContainer}>
            <ExclamationCircle className={styles.errorIcon} />
            <p>
                <strong className={styles.errorImportant}>
                    {formatMessage(errorMessages.error)}
                </strong>
                {formatMessage(errorCopy)}
                {canRetry && <Link onClick={onRetry}>{formatMessage(errorMessages.tryAgain)}</Link>}
            </p>
        </div>
    );
};
